import type { NavImpactSurfaces } from '../arms';

export const spec = (): Partial<NavImpactSurfaces> => ({
  statStyle: 'trend_icon',
  statLayout: 'inline',
});
